module.exports = __webpack_public_path__ + "img/party_upper_5.177669c2.jpg";